import { render } from "./disinfectInfo.vue?vue&type=template&id=4d0c7d36&scoped=true&ts=true"
import script from "./disinfectInfo.vue?vue&type=script&lang=ts"
export * from "./disinfectInfo.vue?vue&type=script&lang=ts"

import "./disinfectInfo.vue?vue&type=style&index=0&id=4d0c7d36&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0c7d36"]])

export default __exports__